import { useEffect, useMemo, useState } from "react";

import differenceBy from "lodash/differenceBy";

import type { SuggestionSchema } from "app/pages/activation/components/Topics/types";
import { useTopicSuggestions } from "app/pages/activation/queries/topics/useTopicSuggestions";

import type { TopicItemSchema } from "../../../components/Topics/Modal/types";

type UseSuggestionItemsSchema = {
    activationId: string;
    createdTopics: SuggestionSchema[];
};

export const useSuggestionItems = ({ activationId, createdTopics }: UseSuggestionItemsSchema) => {
    const { data: suggestions = [], isLoading, isFetching } = useTopicSuggestions(activationId, true);
    const [itemsList, setItemsList] = useState<Partial<TopicItemSchema>[]>([]);

    useEffect(() => {
        if (!suggestions.length) {
            return;
        }
        const uniqueSuggestions = differenceBy(suggestions, createdTopics, "topicName").map((s) => ({
            ...s,
            isSuggestion: true,
        }));

        setItemsList((prev) => prev.filter(({ isSuggestion }) => !isSuggestion).concat(uniqueSuggestions));
    }, [createdTopics, suggestions]);

    const isSuggestionLoading = useMemo(() => isLoading || isFetching, [isLoading, isFetching]);

    return { itemsList, setItemsList, isSuggestionLoading };
};
